import { AbiItem } from 'web3-utils'
import UniversalProfile from '@lukso/lsp-smart-contracts/artifacts/UniversalProfile.json'

export const getDataABI: AbiItem[] = (UniversalProfile.abi as AbiItem[]).filter(
  ({ name }) => name === 'getData' || name === 'getDataBatch'
)
